module.exports = __webpack_public_path__ + "assets/img/travel-day13.cc85ae36.png";